import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { ParityStrategyIssue } from 'lumen/models';

interface ParityTablesCellsTdPromotionTypeSignature {
  Args: {
    cellData: ParityStrategyIssue;
  };
}

const ParityTablesCellsTdPromotionType = <template>
  <div class="text-200--regular flex justify-start gap-100 text-nowrap">
    <PrismIcon @name={{@cellData.platformIcon}} @size="small" />
    <p class="truncate" title={{@cellData.formattedPlatform}}>
      {{@cellData.formattedPlatform}}
    </p>
  </div>
</template> satisfies TOC<ParityTablesCellsTdPromotionTypeSignature>;

export default ParityTablesCellsTdPromotionType;
